/** @format */
// import { Router, Link, Route } from "svelte-routing";
import Web2 from "./Web2.svelte";
// import privacy from "./PrivacyPolicy.svelte";
import App from "./App.svelte";
import Router from "svelte-spa-router";
import Test from "./Test.svelte";
import Test2 from "./Test2.svelte";

import Home from "./routes/Home.svelte";
// import PrivacyPolicy from "./routes/PrivacyPolicy.svelte";

const app = new App({
  // const app = new Web2({
  // target: document.getElementById("app"),
  target: document.body,
});

// // const app = new Test({
// const app = new Test2({
//   // const app = new Home({
//   target: document.body,
// });

export default app;

// // const app = new Web2({
// //   target: document.body,
// //   props: {
// //     name: "world5",
// //   },
// // });

// const app = new Route({
//   target: document.body,
// });

// app.$set({
//   routes: {
//     "/": Web2,
//     "/privacy-policy": privacy,
//   },
// });

// export default app;

// import App from "./App.svelte";
// import TestApp from "./TestApp.svelte";
// import Web from "./Web.svelte";
// import Web2 from "./Web2.svelte";
// import privacy from "./privacy-policy.svelte";
// // import About from "./About.svelte";
// // import About from "./routes/about/About.svelte";
// const app = new Web2({
//   target: document.body,
//   props: {
//     name: "world5",
//   },
// });

// const routes = {
//   "/": app,
//   "/privacy-policy": privacy,
// };
// // app.$set({ routes });
// export default app;
